import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg } from "../../../config/messageconstant";
import { beatJson } from "../../../DynamicFormsJson/MastersJSON/beat";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class BeatView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    if (!this.props.params.id) return;

    const isShowTownInBeat = localStorage.getItem("isShowTownInBeat");
    const showBeatTypeAndDistance = localStorage.getItem(
      "showBeatTypeAndDistance"
    );

    showLoador({ loador: true });

    apiGet({
      url: beatJson.apiBaseURL + "/find-by-id?id=" + this.props.params.id,
    }).then(({ data, success }) => {
      showLoador({ loador: false });

      if (!success) return;

      const beatData = data?.data;
      const DataToSet = [];

      DataToSet.push({
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        label: "Area",
        value: beatData?.areaName || "-",
      });

      if (isShowTownInBeat == 1) {
        DataToSet.push({
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          label: "Town",
          value: beatData?.townName || "-",
        });
      }

      DataToSet.push({
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        label: "Name",
        value: beatData?.beatName || "-",
      });

      if (showBeatTypeAndDistance == 1) {
        DataToSet.push(
          {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            label: "Beat Code",
            value:
              beatData?.beatCode != null
                ? beatData.beatCode
                : "",
          },
          {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            label: "Beat Type",
            value:
              beatData?.type != null
                ? beatData.type == "0"
                  ? "DA Beat"
                  : "TA Beat"
                : "",
          },
          {
            xs: 12,
            sm: 6,
            md: 6,
            lg: 6,
            label: "Distance From HQ",
            value: beatData?.distanceFromHQ || "-",
          }
        );
      }

      DataToSet.push({
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        label: "Sort Order No",
        value: beatData?.sortOrderNo || "-",
      });

      this.setState({ DataToSet });
    });
  }

  render() {
    const { dynamicMasterData, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Beat View"}
            fieldMeta={[]}
            apiBaseURL={beatJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BeatView);
